(function () {

  'use strict';

  angular.module('specsguardApp')
    .value('uiTinymceConfig', {
      document_base_url: 'https://cdn.tiny.cloud/1/dpnl0z61t3gfwmqvfzj5ve50a737cps3kcf27di8enqhm61i/tinymce/4.8.0/'
    })
    .config(appConfig);

  appConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider', '$logProvider',
    '$mdInkRippleProvider', '$mdGestureProvider', '$mdAriaProvider'];

  function appConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $logProvider,
                     $mdInkRippleProvider, $mdGestureProvider, $mdAriaProvider) {
    $urlRouterProvider.otherwise('/');

    $locationProvider.html5Mode(true);
    // allow req.body to be sent on DELETE methods
    $httpProvider.defaults.headers.delete = {'Content-Type': 'application/json;charset=utf-8'};
    $httpProvider.interceptors.push('authInterceptor');
    $httpProvider.interceptors.push('statusInterceptor');
    $httpProvider.interceptors.push('transitionNotifierInterceptor');
    $httpProvider.interceptors.push('noCacheInterceptor');

    $logProvider.debugEnabled(true);

    // Disable 'aria' missing warnings in console.
    $mdAriaProvider.disableWarnings();

    // Ticket SPEC-1824 : uitzetten van material animaties zodat de applicatie soepeler loopt
    // see also https://material.angularjs.org/latest/performance/internet-explorer
    $mdInkRippleProvider.disableInkRipple();

    // Disable al lgesture events, these will break the AngularJS digest cycle in combination with
    // Angular update and ngMaterial causing the digest cycle to fire on all move mouse events
    $mdGestureProvider.skipClickHijack();
    $mdGestureProvider.disableAll();
  }
})();
